module.exports = __webpack_public_path__ + "media/post-listing-block-6-image-step1.eafc224b.png";